// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hx-form-container .canvas-box[data-v-fc8cf97e] {\n  width: 100%;\n  height: 600px;\n}\n", ""]);
// Exports
module.exports = exports;
